// Custom icons: some of the icons' design is changed by Andreas. We should add
// those kind of icons to here
import CheckCustomIcon from "@/assets/svg/custom/check.svg";
import IBGCustomIcon from "@/assets/svg/custom/ibg.svg?component";

// Light FontAwesome Icons
import FilePdfLightIcon from "@/assets/svg/light/file-pdf.svg?component";
import ArrowUpLightIcon from "@/assets/svg/light/arrow-up.svg?component";

// Regular FontAwesome Icons
import BowlHotRegularIcon from "@/assets/svg/regular/bowl-hot.svg?component";
import CircleQuestionRegularIcon from "@/assets/svg/regular/circle-question.svg?component";
import CopyRegularIcon from "@/assets/svg/regular/copy.svg?component";
import ImageRegularIcon from "@/assets/svg/regular/image.svg?component";
import PenToSquareRegularIcon from "@/assets/svg/regular/pen-to-square.svg?component";
import TrashCanRegularIcon from "@/assets/svg/regular/trash-can.svg?component";
import DownloadRegularIcon from "@/assets/svg/regular/download.svg?component";
import ElipsisVerticalRegularIcon from "@/assets/svg/regular/elipsis-vertical.svg?component";
import GripLinesRegularIcon from "@/assets/svg/regular/grip-lines.svg?component";
import PrinterRegularIcon from "@/assets/svg/regular/printer.svg?component";
import RepeatRegularIcon from "@/assets/svg/regular/repeat.svg?component";
import ChevronLeftRegularIcon from "@/assets/svg/regular/chevron-left.svg?component";
import ChevronRightRegularIcon from "@/assets/svg/regular/chevron-right.svg?component";
import ChevronDownRegularIcon from "@/assets/svg/regular/chevron-down.svg?component";
import SignOutRegularIcon from "@/assets/svg/regular/sign-out.svg?component";
import SlidersRegularIcon from "@/assets/svg/regular/sliders.svg?component";
import UserGearRegularIcon from "@/assets/svg/regular/user-gear.svg?component";
import ChevronUpRegularIcon from "@/assets/svg/regular/chevron-up.svg?component";
import XMarkRegularIcon from "@/assets/svg/regular/xmark.svg?component";

// Solid FontAwesome Icons
import BuildingSolidIcon from "@/assets/svg/solid/building.svg?component";
import CheckSolidIcon from "@/assets/svg/solid/check.svg?component";
import CirclePlusSolidIcon from "@/assets/svg/solid/circle-plus.svg?component";
import CircleQuestionSolidIcon from "@/assets/svg/solid/circle-question.svg?component";
import ClipboardCheckSolidIcon from "@/assets/svg/solid/clipboard-check.svg?component";
import EyeSolidIcon from "@/assets/svg/solid/eye.svg?component";
import FilmSolidIcon from "@/assets/svg/solid/film.svg?component";
import EyeSlashSolidIcon from "@/assets/svg/solid/eye-slash.svg?component";
import HouseUserSolidIcon from "@/assets/svg/solid/house-user.svg?component";
import IdCardSolidIcon from "@/assets/svg/solid/id-card.svg?component";
import ImageSolidIcon from "@/assets/svg/solid/image.svg?component";
import InfoCircleSolidIcon from "@/assets/svg/solid/info-circle.svg?component";
import KeySolidIcon from "@/assets/svg/solid/key.svg?component";
import LockSolidIcon from "@/assets/svg/solid/lock.svg?component";
import MessagesLinesSolidIcon from "@/assets/svg/solid/messages-lines.svg?component";
import MessagesSolidIcon from "@/assets/svg/solid/messages.svg?component";
import PersonRunningSolidIcon from "@/assets/svg/solid/person-running.svg?component";
import PhotoVideoSolidIcon from "@/assets/svg/solid/photo-video.svg?component";
import PlusSolidIcon from "@/assets/svg/solid/plus.svg?component";
import RectangleListSolidIcon from "@/assets/svg/solid/rectangle-list.svg?component";
import TriangleExclamationSolidIcon from "@/assets/svg/solid/triangle-exclamation.svg?component";
import RightFromBracketSolidIcon from "@/assets/svg/solid/right-from-bracket.svg?component";
import TagSolidIcon from "@/assets/svg/solid/tag.svg?component";

import UserGearSolidIcon from "@/assets/svg/solid/user-gear.svg?component";
import UsersSolidIcon from "@/assets/svg/solid/users.svg?component";
import UtensilsSolidIcon from "@/assets/svg/solid/utensils.svg?component";
import HouseSolidIcon from "@/assets/svg/solid/house.svg?component";

export const SVGIcons = {
  // custom
  "custom-check": CheckCustomIcon,
  "custom-ibg": IBGCustomIcon,

  // light
  "fal-file-pdf": FilePdfLightIcon,
  "fal-arrow-up": ArrowUpLightIcon,

  // regular
  "far-bowl-hot": BowlHotRegularIcon,
  "far-circle-question": CircleQuestionRegularIcon,
  "far-copy": CopyRegularIcon,
  "far-image": ImageRegularIcon,
  "far-pen-to-square": PenToSquareRegularIcon,
  "far-trash-can": TrashCanRegularIcon,
  "far-download": DownloadRegularIcon,
  "far-elipsis-vertical": ElipsisVerticalRegularIcon,
  "far-grip-lines": GripLinesRegularIcon,
  "far-printer": PrinterRegularIcon,
  "far-repeat": RepeatRegularIcon,
  "far-chevron-left": ChevronLeftRegularIcon,
  "far-chevron-right": ChevronRightRegularIcon,
  "far-chevron-down": ChevronDownRegularIcon,
  "far-sign-out": SignOutRegularIcon,
  "far-sliders": SlidersRegularIcon,
  "far-user-gear": UserGearRegularIcon,
  "far-chevron-up": ChevronUpRegularIcon,
  "far-xmark": XMarkRegularIcon,

  // solid
  "fas-building": BuildingSolidIcon,
  "fas-check": CheckSolidIcon,
  "fas-circle-plus": CirclePlusSolidIcon,
  "fas-circle-question": CircleQuestionSolidIcon,
  "fas-clipboard-check": ClipboardCheckSolidIcon,
  "fas-eye": EyeSolidIcon,
  "fas-film": FilmSolidIcon,
  "fas-eye-slash": EyeSlashSolidIcon,
  "fas-house-user": HouseUserSolidIcon,
  "fas-id-card": IdCardSolidIcon,
  "fas-image": ImageSolidIcon,
  "fas-info-circle": InfoCircleSolidIcon,
  "fas-key": KeySolidIcon,
  "fas-lock": LockSolidIcon,
  "fas-messages-lines": MessagesLinesSolidIcon,
  "fas-messages": MessagesSolidIcon,
  "fas-person-running": PersonRunningSolidIcon,
  "fas-photo-video": PhotoVideoSolidIcon,
  "fas-plus": PlusSolidIcon,
  "fas-rectangle-list": RectangleListSolidIcon,
  "fas-tag": TagSolidIcon,
  "fas-triangle-exclamation": TriangleExclamationSolidIcon,
  "fas-right-from-bracket": RightFromBracketSolidIcon,
  "fas-user-gear": UserGearSolidIcon,
  "fas-users": UsersSolidIcon,
  "fas-utensils": UtensilsSolidIcon,
  "fas-house": HouseSolidIcon,
} as const;

export type SVGName = keyof typeof SVGIcons;
